<app-header class="head{{addClassFromRoute()}}" *ngIf="!hideHeader" id="main-header"></app-header>
<div class="bottom-container w-100 d-flex flex-column flex-grow-1" cdkScrollable>
  <main id="main-container" class="main{{addClassFromRoute()}} flex-fill" >
    <app-contact-support *ngIf="exchangeName !== 'burnx'"  [hidden]="!showForm" (close)="showForm = false" #chat></app-contact-support>
    <router-outlet (activate)="changeOfRoutes()"></router-outlet>
    <div class="footer-margin footer{{addClassFromRoute()}} w-100"></div>
  </main>
  <app-footer class="footer{{addClassFromRoute()}}" *ngIf="!hideFooter" id="main-footer"></app-footer>
</div>
<app-splash></app-splash>